// extracted by mini-css-extract-plugin
module.exports = {"wrap":"St-z","subtitle":"Tt-z","contentWrap":"Ut-z","imgWrap":"Vt-z","heading":"Wt-z","copy":"Xt-z"};